import { render, staticRenderFns } from "./PlaneacionView.vue?vue&type=template&id=2eaa7340&"
import script from "./PlaneacionView.vue?vue&type=script&lang=js&"
export * from "./PlaneacionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports